const on = (eventName:string, listener: any) => {
  const callListener = ({ detail }: any) => {
    listener(detail);
  };
  window.addEventListener(eventName, callListener);
  return () => {
    window.removeEventListener(eventName, listener);
  };
};

const emit = (eventName: string, data: any) => {
  window.dispatchEvent(new CustomEvent(eventName, { detail: data }));
};

export const eventBus = { on, emit };
